/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Form, DatePicker } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import DokanCard from '../card/DokanCard';
import DokanTextInputField from '../form/DokanTextInputField';
import DokanInputLabel from '../form/DokanInputLabel';
import DokanCheckBox from '../form/DokanCheckBox';
import DokanPrexSufxInputTextField from '../form/DokanPrexSufxInputTextField';
import DokanIcons from '../icon/DokanIcons';
import DokanTinyEditor from '../form/DokanTinyEditor';
import DokanDatePicker from '../form/DokanDatePicker';
import DateRangePicker from '../form/DateRangePicker';
import { handleProductInput } from '../../redux/products/productsActions';
import DokanUpload from '../file/DokanUpload';
import DokanMultiUpload from '../file/DokanMultiUpload';
import { priceRegex } from '../../utils/regex';

function General() {
    const dateFormat = 'YYYY-MM-DD';
    const [checkTitle, setCheckTitle] = useState(true);
    const dispatch = useDispatch();
    const productInputData = useSelector((state) => state.products.productInputData);

    const handleChangeInput = (name, value = '', e = null) => {
        dispatch(handleProductInput(name, value, e));
    };

    // schedule date part on/off
    const [schedule, setSchedule] = useState(false);
    const scheduleForm = () => {
        // scRef?.current.scrollIntoView(false);
        setSchedule((prevSchedule) => !prevSchedule);
    };

    // check title length...
    useEffect(() => {
        if (productInputData.name.length > 0) {
            setCheckTitle(false);
        } else {
            setCheckTitle(true);
        }
    }, [productInputData.name]);
    return (
        <>
            <DokanCard hasTitle hasDivider cardTitle="General" hasSvg svgIcon="#product_general">
                <DokanInputLabel>Title</DokanInputLabel>
                <DokanTextInputField
                    onValueChange={handleChangeInput}
                    FormInputName="name"
                    FormItemLabel="Title"
                    FormInputRules={[
                        { required: checkTitle, message: 'Product Title is required' },
                    ]}
                />
                <DokanInputLabel>PermaLink</DokanInputLabel>
                <DokanTextInputField
                    onValueChange={handleChangeInput}
                    FormInputName="permalink"
                    FormItemLabel="permalink"
                    isBorder="false"
                    isInputDisable
                    hasIcon
                    placeholder="http//:myproduct.com/"
                />
                <DokanInputLabel>Product Nature</DokanInputLabel>
                <div className="flex justify-start">
                    <div>
                        <DokanCheckBox
                            label="Virtual"
                            FormInputName="virtual"
                            FormItemLabel="Virtual"
                            isIcon
                            icon="#checkbox_info"
                            onValueChange={handleChangeInput}
                        />
                    </div>
                    <div className="pl-4">
                        <DokanCheckBox
                            FormInputName="downloadable"
                            FormItemLabel="Downloadble"
                            label="Downloadble"
                            isIcon
                            icon="#checkbox_info"
                            onValueChange={handleChangeInput}
                        />
                    </div>
                </div>
                <DokanUpload />
                <DokanMultiUpload />
                <DokanInputLabel>Regular Price</DokanInputLabel>
                {/* <DokanPrexSufxInputTextField
                    onValueChange={handleChangeInput}
                    icon="#cap_dollar"
                    FormInputName="regular_price"
                /> */}
                <DokanTextInputField
                    onValueChange={handleChangeInput}
                    FormInputName="regular_price"
                    FormItemLabel="Regular Price"
                />
                <DokanInputLabel>Sale Price</DokanInputLabel>
                <DokanTextInputField
                    onValueChange={handleChangeInput}
                    FormInputName="sales_price"
                    FormItemLabel="Sale Price"
                >
                    <div className="flex items-center justify-end cursor-pointer">
                        <div>
                            <DokanIcons icon="#inline_calendar" />
                        </div>
                        <div className="text-mattBlue text-right font-normal px-2">
                            <button type="button" onClick={scheduleForm}>
                                {`${schedule ? 'Cancel' : 'Schedule'}`}
                            </button>
                        </div>
                    </div>
                    <div className={`${schedule ? 'flex justify-evenly items-center' : 'hidden'}`}>
                        <div>
                            <Form.Item name="date_on_sale_from" label="From">
                                <DatePicker
                                    format={dateFormat}
                                    onChange={(e) =>
                                        handleChangeInput(
                                            'date_on_sale_from',
                                            `${e.format(dateFormat)}`
                                        )
                                    }
                                    placeholder="Start Date"
                                />
                            </Form.Item>
                        </div>
                        <div>
                            <Form.Item name="date_on_sale_to" label="To">
                                <DatePicker
                                    format={dateFormat}
                                    onChange={(e) =>
                                        handleChangeInput(
                                            'date_on_sale_to',
                                            `${e.format(dateFormat)}`
                                        )
                                    }
                                    placeholder="End Date"
                                />
                            </Form.Item>
                        </div>
                    </div>
                </DokanTextInputField>
                <DokanInputLabel>Description</DokanInputLabel>
                <DokanTinyEditor
                    setHeight="200px"
                    FormInputName="description"
                    onValueChange={handleChangeInput}
                />
                <DokanInputLabel>Short Description</DokanInputLabel>
                <DokanTinyEditor
                    setHeight="200px"
                    FormInputName="short_description"
                    onValueChange={handleChangeInput}
                />
            </DokanCard>
        </>
    );
}

export default General;
